import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { RootState } from "../../types";
import { axiosClient } from "../../../api/axios-client";
import { PostInputSubmissionResponseDto } from "../../../types/dto/chat/send-input-submission-response-dto";
import { PostInputSubmissionRequestDto } from "../../../types/dto/chat/send-input-submission-request-dto";
import { sendMessageLogSubmission } from "./send-message-log";
import VurbalizeEvents from "../../../types/dto/chat/vurbalize-events";
import getMessageByVurablizeEvent from "../../../../application/utils/get-message-by-vurablize-event";

export const postCallSchedules = createAsyncThunk<
  PostInputSubmissionResponseDto
>(
  "chat-slice/post-call-schedules",
  async (
    _,
    { getState, signal, rejectWithValue, fulfillWithValue, dispatch }
  ) => {
    const state = getState() as RootState;

    const { suId, conversationId, merchId, sessionId } = state["app-state"];
    const { messages } = state["chat"];
    const turnId = messages[messages.length - 1].turn_id;

    // const reqBody: PostCallScheduledRequestDto = {
    const reqBody = {
      conversation_id: conversationId,
      cust_id: merchId,
      session_id: sessionId,
      su_id: suId,
      turn_id: turnId,
      cookies: document.cookie
    }

    const response = await axiosClient.post<PostInputSubmissionResponseDto>(
      "/post-call-scheduled",
      reqBody,
      { signal },
    );
    if (response.status !== HttpStatusCode.Ok) {
      // Return the known error for future handling
      return rejectWithValue(response.data);
    }

    dispatch(sendMessageLogSubmission({
      data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.HUBSPOT_MEETING_SCHEDULED),
        event_name: VurbalizeEvents.HUBSPOT_MEETING_SCHEDULED,
        event_data: {
          timestamp: Date.now(),
          currentUrl: window.location.href
        },
      },
    }));

    return fulfillWithValue(response.data);
  }
);
